import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BrandService } from './shared/services/brand.service';
import { ThemeService } from './shared/services/theme.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(
    private readonly translate: TranslateService,
    private readonly themeService: ThemeService,
    private readonly brandService: BrandService,
  ) {
    this.translate.setDefaultLang('en');
    this.translate.use('en');
  }

  ngOnInit(): void {
    // BrandService constructor detects host + applies body class.
    // Theme CSS is loaded via ThemeService and varies per brand deployment.
    this.themeService.setTheme(this.brandService.current.themeName);
  }

  applyTheme($event: Event): void {
    const target = $event.target as HTMLInputElement;
    this.themeService.setTheme(target.value);
  }
}
